import { Component, OnInit } from '@angular/core';
import { ServiceLayer } from 'src/app/services/serviceLayer';
import { Settings } from '../../services/settings';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  public quotestab:boolean=false;
  constructor(public serviceLayer:ServiceLayer,private settings:Settings) { }

  ngOnInit(): void {
  }

  CreateOnlineQuote() {
    let quoteURL = this.settings.quickQuotePolicyUrl + 'Questions/BFM/BR/';
    window.open(quoteURL);
  }
  clickDocument(){
    this.serviceLayer.openLink('documentCenter','',0);
  }

}
